import { TmElement, watch } from '@thiememeulenhoff/lit-sdk';
import { SkeletonVariant } from '@thiememeulenhoff/types';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles, tag } from './skeleton.styles';

@customElement(tag)
export class SkeletonComponent extends TmElement {
  static override styles = [...styles];

  @property({ type: String, reflect: true })
  variant: SkeletonVariant = 'text';

  @property({ type: Number })
  width?: number;

  @property({ type: Number })
  height?: number;

  protected override onCreate = () => {
    this.setAttribute('aria-hidden', 'true');
  };

  @watch('width')
  @watch('height')
  onWidthOrHeightChange() {
    this.style.inlineSize = this.width ? `${this.width}px` : '';
    this.style.blockSize = this.height ? `${this.height}px` : '';
  }

  override render() {
    return html`<div class="skeleton"></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-skeleton': SkeletonComponent;
  }
}
